var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKorean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_172_1333",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 33,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 0.00195312H31.0005V23.002H-0.000976562V0.00195312Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_172_1333)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000976562 0.00195312H31.0051V23.002H-0.000976562V0.00195312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.39551 6.95508L6.6873 2.20304L7.47657 2.74269L4.18477 7.49473L3.39551 6.95508ZM4.57941 7.76455L7.8712 3.01251L8.66047 3.55216L5.36867 8.3042L4.57941 7.76455ZM5.76331 8.57403L9.0551 3.82199L9.84436 4.36164L6.55257 9.11368L5.76331 8.57403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.127 18.6523L24.4187 13.9003L25.208 14.44L21.9162 19.192L21.127 18.6523ZM22.3109 19.4618L25.6026 14.7098L26.3919 15.2494L23.1001 20.0015L22.3109 19.4618ZM23.4948 20.2713L26.7865 15.5193L27.5758 16.0589L24.284 20.8109L23.4948 20.2713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1252 19.0313L22.1025 16.3672L22.577 15.6794L26.5997 18.3435L26.1252 19.0313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6494 8.25781C11.5228 7.00472 12.8663 6.14218 14.3844 5.85995C15.9025 5.57771 17.4707 5.8989 18.7442 6.75285C20.0177 7.6068 20.8921 8.92357 21.175 10.4135C21.4579 11.9034 21.1262 13.4444 20.2528 14.6975L10.6494 8.25781Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7174 8.28805C9.84418 9.54188 9.51082 11.0849 9.7907 12.5777C10.0706 14.0705 10.9408 15.3908 12.2098 16.2481C13.4789 17.1054 15.0429 17.4295 16.5578 17.1491C18.0726 16.8688 19.4142 16.0068 20.2875 14.753C20.7241 14.1261 20.8908 13.3546 20.7509 12.6082C20.6109 11.8618 20.1758 11.2016 19.5413 10.773C18.9068 10.3443 18.1248 10.1823 17.3673 10.3225C16.6099 10.4627 15.9391 10.8936 15.5025 11.5205L10.7174 8.28805Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4537 11.5321C16.3618 10.225 16.0295 8.43998 14.7116 7.5451C13.3937 6.65022 11.5893 6.98438 10.6812 8.29149C9.77322 9.59859 10.1055 11.3836 11.4234 12.2785C12.7412 13.1734 14.5457 12.8392 15.4537 11.5321Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70117 20.8145L3.40938 16.0624L4.19865 15.5228L7.49044 20.2748L6.70117 20.8145ZM7.88507 20.005L4.59328 15.2529L5.38255 14.7133L8.67434 19.4653L7.88507 20.005ZM9.06897 19.1955L5.77718 14.4435L6.56645 13.9038L9.85824 18.6559L9.06897 19.1955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4326 9.11719L21.1408 4.36515L21.9301 3.8255L25.2219 8.57754L24.4326 9.11719ZM25.6165 8.30771L22.3247 3.55567L23.114 3.01602L26.4058 7.76806L25.6165 8.30771ZM26.8004 7.49824L23.5086 2.7462L24.2979 2.20655L27.5897 6.95859L26.8004 7.49824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47533 17.3059L6.2666 18.1035L5.79585 17.4099L7.00459 16.6123L7.47533 17.3059ZM23.9947 6.40585L22.5845 7.33635L22.1137 6.6427L23.5239 5.7122L23.9947 6.40585ZM26.4121 4.81071L25.2034 5.60828L24.7327 4.91463L25.9414 4.11707L26.4121 4.81071Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorean);
export default __webpack_public_path__ + "static/media/Korean.ef6535ed8f65196cc809864cc0e8c519.svg";
export { ForwardRef as ReactComponent };